import { render } from "./RegistrationStart.vue?vue&type=template&id=1ba8560e"
import script from "./RegistrationStart.vue?vue&type=script&lang=js"
export * from "./RegistrationStart.vue?vue&type=script&lang=js"
script.render = render

export default script